import React from "react";
import { useTheme } from "@material-ui/core/styles";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Typography from "@material-ui/core/Typography";
import { i18n } from "../../../translate/i18n";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const ContactsByUserChart = ({ data = [], title = i18n.t("usageReport.chart.totalContactsByUser") }) => {
  const theme = useTheme();
  const isDark = theme.palette.type === "dark";
  const textColor = isDark ? "#e0e0e0" : "#333333";
  const gridColor = isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.1)";

  if (!data.length) {
    return null;
  }

  const chartData = {
    labels: data.map((d) => d.name),
    datasets: [
      {
        data: data.map((d) => d.quantidade),
        backgroundColor: "#2DDD7F",
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      datalabels: {
        anchor: "end",
        align: "end",
        color: textColor,
        font: {
          weight: "bold",
        },
        formatter: (value) => Math.trunc(Number(value) || 0),
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: { color: textColor },
        grid: { color: gridColor },
      },
      y: {
        ticks: { color: textColor },
        grid: { color: gridColor },
      },
    },
  };

  return (
    <>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        {title}
      </Typography>
      <Bar options={options} data={chartData} />
    </>
  );
};

export default ContactsByUserChart;
